

















import { Component, Vue, Prop } from "vue-property-decorator";
import { ReportData } from "@/types";
import AnimatedNumber from "animated-number-vue";

@Component({
  name: "FormatServicesAnimationLine",

  components: {
    AnimatedNumber,
  }
})
export default class FormatServices extends Vue {
  @Prop({ type: Object, required: true }) item!: ReportData;
  @Prop({ type: String, default: "#c2d2bb" }) background!: string;
  @Prop({ type: Boolean, default: false }) hiddenTitle!: boolean;
  @Prop({ type: Number, required: true }) maxValue!: number;
  @Prop() totalValue!: number;

  width: number = 0;
  animated = false;

  itemWidth() {
    const stepSize = 40;
    const lineWidth = Math.floor((this.item.value * 100) / this.maxValue);
    const step = lineWidth / stepSize;

    const interval = () => {
      if (this.width >= Math.floor(lineWidth)) {
        this.animated = true;
        return;
      }

      this.width += step;
      requestAnimationFrame(interval);
    };

    requestAnimationFrame(interval);
  }

  mounted() {
    this.itemWidth();
  }
}
